export default __webpack_public_path__ + "static/media/aboutpic.87977116.jpg";